module.exports = __webpack_public_path__ + "img/pied-billed-grebe.76f4158a.jpg";